// react
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from 'router';

// components
import { ChromeTemplate } from '@karehero/llama/pwa/templates/ChromeTemplate/ChromeTemplate';
import { type LinkItem } from '@karehero/llama/pwa/molecules/NavDrawer/NavDrawer';

/**
 * RootOrganizationOwner is the root layout for organization-owner pages.
 * Uses ChromeTemplate for consistent navigation behaviour with other roots.
 */
export const RootOrganizationOwner = () => {
  // hooks
  const navigate = useNavigate();
  const location = useLocation();

  const links: LinkItem[] = useMemo(
    () => [
      {
        icon: 'paper-plane-top',
        label: 'Invite Portal',
        to: ROUTES.PORTAL,
        onClick: () => navigate(ROUTES.PORTAL),
      },
      {
        icon: 'book',
        label: 'Resources',
        to: ROUTES.RESOURCES,
        onClick: () => navigate(ROUTES.RESOURCES),
      },
    ],
    [navigate],
  );

  return <ChromeTemplate links={links} activePath={location.pathname} />;
};

RootOrganizationOwner.displayName = 'RootOrganizationOwner';
export default RootOrganizationOwner;
